<template>
  <div class="box">
    <div class="addTraining">
    <van-form @submit="onSubmit">
        <van-cell-group>
          <!-- <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.empno" placeholder="请输入工号" label="工号"/> -->
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.type" placeholder="请输入课程类型" label="课程类型"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.subject" placeholder="请输入课程名称" label="课程名称"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" type="date" @change="setStateTime" v-model="baseinfo.begindate" placeholder="请输入参与时间" label="参与时间"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" type="date" @change="setEndTime" v-model="baseinfo.enddate" placeholder="请输入结束时间" label="结束时间"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.address" placeholder="请输入培训地点" label="培训地点"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.hours" placeholder="请输入课程时长" label="课程时长"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.certname" placeholder="请输入所获证书" label="所获证书"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.certno" placeholder="请输入证书编号" label="证书编号"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.organizer" placeholder="请输入主办单位" label="主办单位"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.teacher" placeholder="请输入授课讲师" label="授课讲师"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.development" placeholder="请输入开展形式" label="开展形式"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.traintype" placeholder="请输入培训类型" label="培训类型"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.trainmoney" placeholder="请输入培训费用" label="培训费用"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.trainagreement" placeholder="请输入培训协议" label="培训协议"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.score" placeholder="请输入考试成绩" label="考试成绩"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.credit" placeholder="请输入所获学分" label="所获学分"/>
        </van-cell-group>
        <div class="btnBox">
            <van-button round block type="info" native-type="submit" class="btn">确认</van-button>
        </div>
    </van-form>
    <div class="footer">
      <van-button round block class="btnClo" @click="toInfo">取消</van-button>
    </div>
  </div>
  </div>
</template>

<script>
import api from '@/apis'
import moment from 'moment'
export default {
  name: "addTraining",
  data(){
    return {
      baseinfo:{
        "empno": "", //员工工号
        "type": "", //课程类型
        "subject": "", //课程名称
        "course": "",
        "begindate": "", //参与时间
        "enddate": "", //结束时间
        "address": "", //培训地点
        "hours": 1, //课程时长
        "certname": "", //所获证书
        "certno": "", //证书编号
        "remark": "",
        "organization": "",
        "position": "",
        "company": "",
        "organizer": "", //主办单位
        "teacher": "", //授课讲师
        "development": "", //开展形式
        "traintype": "", //培训类型
        "trainmoney": "", //培训费用
        "trainagreement": "", //培训协议
        "score": "", //考试成绩
        "credit": "", //所获学分
      }
    }
  },
  methods: {
    //提交
    onSubmit(){
      let obj = {
        ...this.baseinfo,
        begindate:moment(this.baseinfo.begindate).format('YYYY-MM-DD'),
        enddate:moment(this.baseinfo.enddate).format('YYYY-MM-DD'),
        table:'euBgtrainingList',
        saveType:'1',
        empid:this.$store.state.userInfo.empID,
        empno:this.$store.state.userInfo.empNo,
      }
      api.setSaveEmpInfo(obj).then(()=>{
        this.$toast('添加成功');
        this.$router.push({
        path:'/mobile/info',
        query:{
          type:'add'
        }
        })
      })
    },
    //跳转
    toInfo(){
      this.$router.push({
        path:'/mobile/info',
        query:{
          type:'no'
        }
      })
    },
    //参与时间判断
    setStateTime(){
      if(this.baseinfo.begindate>this.baseinfo.enddate  && this.baseinfo.enddate){
        this.$toast('参与时间不能大于结束时间')
        this.baseinfo.begindate = ''
      }
    },
    //结束时间判断
    setEndTime(){
      if(this.baseinfo.enddate<this.baseinfo.begindate){
        this.$toast('结束时间不能小于参与时间')
        this.baseinfo.enddate = ''
      }
    }
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .addTraining {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .addTraining {
    width: 276px * $zoom;
  }
}
.box{
  display: flex;
  justify-content: center;
}
.addTraining {
  font-size: 16px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
}
.fromBox{
    height: 90vh;
}
.btnBox{
    width: 50%;
    position: absolute;
    bottom: 20px * $zoom;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px * $zoom 20px * $zoom;
    margin-left: 50%;
}
.btn {
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
}
.footer{
  width: 50%;
  position: absolute;
  bottom: 20px * $zoom;
  display: flex;
  justify-content: flex-end;
  padding: 10px * $zoom 20px * $zoom;
}
.btnClo{
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
  border: none;
}
</style>
